<!-- Main Content Card -->
<div class="content-card">
  <div class="card-header">
    <h3 class="card-title">
      <svg>
        <use href="assets/icons.svg#airplane"></use>
      </svg>
      Complete order
    </h3>
  </div>

  <div class="card-content">
    <!-- Success Message -->
    <div class="success-section">
      <div class="success-icon">
        <svg>
          <use href="assets/icons.svg#checked"></use>
        </svg>
      </div>
      <h2 class="success-title">Order Submitted!</h2>
      <p class="success-message">Broadband installation request has been successfully processed</p>
    </div>

    <!-- Order Reference -->
    <div class="reference-box">
      <div class="reference-text">
        <div class="reference-label">Order Reference</div>
        <div class="reference-value">{{ orderReference }}</div>
      </div>
      <button class="btn copy-btn" type="button" (click)="copyReference()">
        <svg>
          <use href="assets/icons.svg#copy"></use>
        </svg>
      </button>
    </div>

    <!-- Customer Details Summary -->
    <div class="summary-section">
      <h4 class="summary-title">
        <svg>
          <use href="assets/icons.svg#person"></use>
        </svg>
        Customer Details
      </h4>
      <div class="detail-row">
        <span class="detail-label">Name:</span>
        <span class="detail-value">{{ customerName }}</span>
      </div>
      <div class="detail-row">
        <span class="detail-label">Email:</span>
        <span class="detail-value">{{ customerEmail }}</span>
      </div>
      <div class="detail-row">
        <span class="detail-label">Phone:</span>
        <span class="detail-value">{{ customerPhone }}</span>
      </div>
      <div class="detail-row">
        <span class="detail-label">Address:</span>
        <span class="detail-value">{{ customerAddress }}</span>
      </div>
    </div>

    <!-- Service Package Summary -->
    <div class="summary-section">
      <h4 class="summary-title">
        <svg>
          <use href="assets/icons.svg#package"></use>
        </svg>
        Service Package
      </h4>
      <div class="detail-row">
        <span class="detail-label">Package:</span>
        <span class="detail-value">{{ packageName }}</span>
      </div>
      <div class="detail-row">
        <span class="detail-label">Speed:</span>
        <span class="detail-value">{{ packageSpeed }}</span>
      </div>
      <div class="detail-row">
        <span class="detail-label">Monthly fee:</span>
        <span class="detail-value">{{ packagePrice }}</span>
      </div>
    </div>

    <!-- Next Steps -->
    <div class="next-steps">
      <h4 class="steps-title">
        <svg>
          <use href="assets/icons.svg#document"></use>
        </svg>
        Next Steps
      </h4>
      <ol class="steps-list">
        <li>
          <span class="step-number">1</span>
          <div>
            <span class="step-name">Confirmation Email</span>
            <span class="step-desc">Contract and order details sent to customer's email</span>
          </div>
        </li>
        <li>
          <span class="step-number">2</span>
          <div>
            <span class="step-name">Technical Survey</span>
            <span class="step-desc">Engineer will contact customer within 3-5 business days</span>
          </div>
        </li>
        <li>
          <span class="step-number">3</span>
          <div>
            <span class="step-name">Installation</span>
            <span class="step-desc">Scheduled within 2-4 weeks from completion</span>
          </div>
        </li>
      </ol>
    </div>

    <!-- Action Button -->
    <div class="action-buttons">
      <button class="btn btn-primary btn-done" type="button" (click)="startNewOrder()">
        <svg>
          <use href="assets/icons.svg#airplane"></use>
        </svg>
        Start New Sale
      </button>
    </div>

    <!-- Information -->
    <div class="footnote-section">
      <p class="footnote">
        Order reference: {{ orderReference }} • Submitted at {{ submissionTime }}
      </p>
    </div>
  </div>
</div>
